import { ControlPanelService } from 'src/states/control-panel.service';
import { Injectable, EventEmitter } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs/internal/operators/map';
import { take } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private controlPanelService: ControlPanelService) {}

    canActivate(route: ActivatedRouteSnapshot) {
      return this.controlPanelService.isLoggedIn$.pipe(
        take(1),
        map(isLoggedIn => {

          if (route.routeConfig.path === 'auth') {
            return true;
          }

          const isLoginForm = route.routeConfig.path === 'login'
          || route.routeConfig.path === 'login-citoyen'
          || route.routeConfig.path === 'password-reset'
          || route.routeConfig.path === 'password-reset-citoyen'
          || route.routeConfig.path === 'password-forgotten';

          if (isLoggedIn && isLoginForm) {
            this.router.navigate(['/']);
            return false;
          }

          if (isLoggedIn) {
              return true;
          } else {
            if (!isLoginForm) {
              this.router.navigate(['/auth', 'login']);
              return false;
            }
            return isLoginForm;
          }
        })
      );
    }
}
